import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Input } from 'reactstrap';
import { FieldLabel } from '@puckeditor/core';

const ClearableNumberInput = ({
  hint,
  value,
  onChange,
  label,
  min,
  max,
  step,
}) => {
  const [local, setLocal] = useState(value ?? '');

  useEffect(() => {
    if (value === null || typeof value === 'undefined' || value === '') {
      setLocal('');
      return;
    }
    setLocal(value);
  }, [value]);

  const handleChange = (e) => {
    const raw = e.currentTarget.value;
    setLocal(raw);
    if (raw === '') {
      onChange(null);
      return;
    }

    const n = parseInt(raw);
    if (!Number.isNaN(n)
      && (typeof min === 'undefined' || n >= min)
      && (typeof max === 'undefined' || n <= max)) {
      onChange(n);
    }
  };

  return (
    <FieldLabel label={label} className="w-100 d-block">
      {hint && (
        <div className="puck-common-field-hint">
          {hint}
        </div>
      )}
      <Input
        type="number"
        min={min}
        max={max}
        step={step}
        value={local}
        onChange={handleChange}
        className="puck-field-input-top-gap w-100"
      />
    </FieldLabel>
  );
};

ClearableNumberInput.propTypes = {
  hint: PropTypes.string,
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
};

ClearableNumberInput.defaultProps = {
  hint: '',
  value: null,
  min: undefined,
  max: undefined,
  step: 1,
};

export default ClearableNumberInput;
